import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchSignTypeComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getSignTypes from '../../services/signType/getSignTypes'

export function * fetchSignTypeCombo () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const signTypes = yield call(getSignTypes, auth.token)
    yield put(fetchSignTypeComboSuccess(signTypes))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchSignTypeCombo () {
  yield takeLatest(combosActionTypes.FETCH_SIGN_TYPE, fetchSignTypeCombo)
}
